import {observable, action} from 'mobx';

export class SchemeStore {
  @observable appDatas = [];
  @observable schemeDatas = [];
  @observable whereType = "";


  @observable addModal = {
    addWhere: "0",
    visible: false,
    title: "添加应用",
    datas: [],//存放添加项目数据，项目数据或方案数据
    cloumns: []
  }

  @observable applyModal = {
    visible: false,
    title: "申请应用"
  }


  @observable createSchemeModal = {
    visible: false,
    title: "创建方案"
  }

  @observable leftMenu = "proj";

  @observable projSearchData = {
    projName: "",
    proj: "",
    type: "",
    appName: ""
  }

  @observable schemeSearchData = {
    schemeName: "",
    scheme: "",
    type: "",
    appName: ""
  }

  @observable searchData = {
    whereName: "",
    wherekey: "",
    type: "",
    appName: ""
  }

  @observable routes = [];
  @observable current = 1;
  @observable pageSize = 10;
  @observable selectedRows = [];
  @observable searchValue = {
    application: '',
    category: '0'
  };
  constructor(routing) {
    this.routing = routing;
    this.setPage = this.setPage.bind(this);
    this.getRoutes = this.getRoutes.bind(this);
  }

  @action
  callAppData(schemeParam) {
    this.schemeSearchData = {...this.schemeSearchData, scheme: schemeParam}
    setTimeout(() => {
      this.appDatas = require("../../mocks/scheme/datas_scheme_app.json");//todo 根据project获取应用
    }, 300);
  }

  callSchemeData(leftMenuParams, params) {
    this.searchData = {...this.searchData, whereName: "", wherekey: ""};
    this.leftMenu = leftMenuParams;
    setTimeout(() => {
      this.schemeDatas = require("../../mocks/scheme/datas_scheme_" + params.id + ".json");
    }, 300);
  }

  callAddWhereData(params, filter, query) {
    let where = "";
    if (params === "2") {
      this.addModal = {
        ...this.addModal, addWhere: "2", title: "项目", cloumns: [{
          title: '项目名称',
          dataIndex: 'name',
        }, {
          title: '项目类别',
          dataIndex: 'type',
        }]
      }
      where = "project";
    } else if (params === "3") {
      this.addModal = {
        ...this.addModal, addWhere: "3", title: "方案", cloumns: [{
          title: '方案名称',
          dataIndex: 'name',
        }]
      }
      where = "scheme";
    }
    setTimeout(() => {
      this.addModal = {
        ...this.addModal,
        datas: require("../../mocks/" + where + "/datas_" + where + "_" + query.id + ".json")
      };
      if (filter && filter !== "") {
        console.log("filter:", filter);
        let temp = [];
        this.addModal.datas.filter(function (el) {
          if (el && el.name.indexOf(filter) >= 0) {
            temp.push(el);
          }
        });
        this.addModal = {...this.addModal, datas: temp};
      }
      this.addModal = {...this.addModal, visible: true};
    }, 300);
  }

  callToAddAPP(app, where) {
    //??todo:添加应用到相应选择
    console.log("----callToAddAPP", app, where);
  }

  setPage(current, pageSize) {
    this.current = current;
    this.pageSize = pageSize;
  }

  getRoutes(params) {
    this.routes = [{
      key: '1',
      breadcrumbName: '云商店',
      path: '/'
    }];
    if (params.id && params.id === 'all') {
      this.routes.push({
        key: '2',
        breadcrumbName: '全部应用',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'workflow') {
      this.routes.push({
        key: '2',
        breadcrumbName: '流程应用',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'portal') {
      this.routes.push({
        key: '2',
        breadcrumbName: '门户应用',
        path: '/app/list'
      });
    }
    // this.routes.push({
    //   key: '3',
    //   breadcrumbName: '我的方案',
    //   path: '/app/scheme'
    // });
  }

}


// WEBPACK FOOTER //
// ./src/stores/scheme/SchemeStore.js